import { render } from "./UserMessages.vue?vue&type=template&id=47eb76b4"
import script from "./UserMessages.vue?vue&type=script&lang=js"
export * from "./UserMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__